import '../ListingSources/ListingSources.scss';
import './OwnerResearch.scss';
import Component from './OwnerResearch.js';
export default Component;
